import type { ReactNode } from 'react';
import { Tabs, TabList, Tab, TabPanels, TabPanel } from '@reach/tabs';
import styled from 'styled-components';

// reset default styles
const StyledTab = styled(Tab)`
  border: none;
  background: transparent;
  cursor: pointer;
  padding: 0;
  font-family: inherit;
`;

const StyledTabs = styled(Tabs)`
  font-family: inherit;
`;

const StyledTabList = styled(TabList)`
  font-family: inherit;
`;

const StyledTabPanels = styled(TabPanels)`
  font-family: inherit;
`;

const StyledTabPanel = styled(TabPanel)`
  font-family: inherit;
`;

export interface ReachTabsProps {
  index?: number;
  children?: ReactNode;
  onChange?: (index: number) => void;
  className?: string;
}

export interface ReachTabPanelProps {
  children: ReactNode;
  className?: string;
}

const ReachTabsPrimitive = {
  Root: ({ index, children, onChange, className }: ReachTabsProps) => (
    <StyledTabs index={index} onChange={onChange} className={className}>
      {children}
    </StyledTabs>
  ),
  // List doesn't have aria-labelledby auto-generated by Reach. But it's ok because it is only recommended.
  // Ref: https://www.w3.org/WAI/ARIA/apg/practices/names-and-descriptions/#naming_role_guidance_heading
  List: ({
    children,
    className,
  }: {
    children: React.ReactNode;
    className?: string;
  }) => <StyledTabList className={className}>{children}</StyledTabList>,
  Tab: ({
    children,
    className,
  }: {
    children: React.ReactNode;
    className?: string;
  }) => <StyledTab className={className}>{children}</StyledTab>,
  Panels: ({
    children,
    className,
    style,
  }: {
    children: React.ReactNode;
    className?: string;
    style?: React.CSSProperties;
  }) => (
    <StyledTabPanels style={style} className={className}>
      {children}
    </StyledTabPanels>
  ),
  Panel: ({ children, className }: ReachTabPanelProps) => {
    return <StyledTabPanel className={className}>{children}</StyledTabPanel>;
  },
};

export default ReachTabsPrimitive;
